import { Dialog } from '@cimplico/components';
import { toastNotification } from '../../components/toast/Toast';
import { useUpdateClientQueries } from '../../queries/use-update-client-queries';
import { ClientQueryStatusEnum } from '../../types/client-query';

type ClientQueryActiveConfirmProps = {
    clientQueryId: string;
    workpaperId: string;
    onClose: () => void;
};

function ClientQueryActiveConfirm({ clientQueryId, workpaperId, onClose }: ClientQueryActiveConfirmProps): JSX.Element {
    const updateClientQueriesQuery = useUpdateClientQueries(workpaperId);

    function updateClientQueryStatus(): void {
        updateClientQueriesQuery.mutate([{ id: clientQueryId, fields: { status: ClientQueryStatusEnum.ACTIVE } }], {
            onSuccess: () => {
                onClose();
                toastNotification('success', 'Client query marked as active!');
            },
        });
    }

    return (
        <Dialog
            type="info"
            title="Mark as Active"
            description="Do you want to mark this resolved client query as active? Any applicable worksheets / other schedules will be unreviewed"
            primaryAction="Confirm"
            secondaryAction="Cancel"
            isOpen
            onClose={onClose}
            onPrimaryActionClick={updateClientQueryStatus}
            onSecondaryActionClick={onClose}
            isLoading={updateClientQueriesQuery.isLoading}
        />
    );
}
export default ClientQueryActiveConfirm;
